import configuredAxios from '../axios.js'

export default {
  install(app) {
    // Make axios available globally
    app.config.globalProperties.$axios = configuredAxios
    app.provide('axios', configuredAxios)
  }
} 